module.exports = __webpack_public_path__ + "img/Iceland.4dbbbcf7.png";